import { useEffect, useMemo, useState } from "react";
import { Table } from "@tw/tw-common-js";
import { formatDate } from "../../services/utils";
import { useAuth } from "../../context/useAuth";
import api from "../../services/api";

export default function RolePrivilegeHistory({ roleId }) {
  const { privilegeLabels } = useAuth();
  const [logs, setLogs] = useState([]);

  // Flat map of privilege key -> human label, derived from the grouped privilegeLabels.
  const labelMap = useMemo(() => {
    const map = {};
    Object.values(privilegeLabels || {}).forEach((section) => {
      Object.entries(section).forEach(([key, val]) => {
        map[key] = val.label || key;
      });
    });
    return map;
  }, [privilegeLabels]);

  useEffect(() => {
    async function fetchLogs() {
      try {
        const res = await api.getRolePrivilegeAuditLog(roleId);
        if (res.status === 200) setLogs(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        console.error("Error fetching role privilege history:", err);
      }
    }
    if (roleId) fetchLogs();
  }, [roleId]);

  const labelFor = (key) => labelMap[key] || key;

  const diffPrivileges = (row) => {
    const oldArr = Array.isArray(row.oldValue) ? row.oldValue : [];
    const newArr = Array.isArray(row.newValue) ? row.newValue : [];
    const added = newArr.filter((p) => !oldArr.includes(p));
    const removed = oldArr.filter((p) => !newArr.includes(p));
    return { added, removed };
  };

  const config = {
    columns: [
      { key: "date", header: "Date", template: (row) => formatDate(row.date, true) },
      {
        key: "added",
        header: "Added",
        template: (row) => {
          const { added } = diffPrivileges(row);
          return added.length ? added.map(labelFor).join(", ") : "-";
        },
      },
      {
        key: "removed",
        header: "Removed",
        template: (row) => {
          const { removed } = diffPrivileges(row);
          return removed.length ? removed.map(labelFor).join(", ") : "-";
        },
      },
      { key: "actorLabel", header: "Changed By", template: (row) => row.actorLabel || "-" },
    ],
  };

  return (
    <div className="table-container with-borders no-vertical-scroll">
      <Table
        data={logs}
        config={config}
        emptyMessage="No privilege changes recorded."
        className="changelog-table"
        enableColumnVisibility={false}
        enableColumnOrdering={false}
        hideIcon={true}
      />
    </div>
  );
}
